import React from 'react';

/**
 * 検索フォームヘッダー
 * @props {number}total:検索結果数
 * @props {boolean}isOpened:検索条件開閉フラグ
 * @props {string}accordionButtonClass:開閉ボタンのclass属性
 * @props {string}accordionButtonName:開閉ボタンのname属性
 * @props {string}clearButtonClass:検索条件クリアボタンのclass属性
 * @props {string}clearButtonName:検索条件クリアボタンのname属性
 * @props {function}searchFormHandle:検索条件を開閉処理
 * @props {function}clearSearchProperty:検索条件のクリア処理
 */
export class SearchMenuHeader extends React.Component {
  constructor(props) {
    super(props);

    if (
      this.props.searchFormHandle !== undefined &&
      typeof this.props.searchFormHandle === 'function'
    ) {
      this.searchFormHandle = this.props.searchFormHandle.bind(this);
    } else {
      console.warn('searchFormHandle is not function');
    }

    if (
      this.props.clearSearchProperty !== undefined &&
      typeof this.props.clearSearchProperty === 'function'
    ) {
      this.clearSearchProperty = this.props.clearSearchProperty.bind(this);
    } else {
      console.warn('clearSearchProperty is not function');
    }
  }

  // 画面表示
  render() {
    return (
      <div className='search-form__header'>
        <div className='search-form__title'>
          検索条件（検索結果
          <span className='bold'>{this.props.total}</span>
          件)
        </div>
        <button
          id='setting-search-accordion-toggle'
          className={`${this.props.accordionButtonClass} ${
            this.props.isOpened ? 'accordion__btn show' : 'accordion__btn'
          }`}
          name={this.props.accordionButtonName}
          onClick={this.searchFormHandle}
        />
        <button
          className={`${this.props.clearButtonClass}` + ' btn-text--sm'}
          name={this.props.clearButtonName}
          onClick={this.clearSearchProperty}
        >
          {data.clearButtonTitle}
        </button>
      </div>
    );
  }
}

// 定数
const data = {
  clearButtonTitle: '検索条件クリア',
};



// WEBPACK FOOTER //
// ./src/components/searchmenus/SearchMenuHeader.jsx